export function QBOSupportClearDuplicatesCtrl ($scope, $uibModalInstance, workshopAPI, result) {

  $scope.result = result ? result : {};
}